export enum UserStatusFilters {
  ALL = "All",
  ENABLED = "Enabled",
  DISABLED = "Disabled",
}
